import * as types from "./invoicesActionTypes";

export default function invoicesReducer(state = {}, action) {
  switch (action.type) {
    case types.REFRESH_INVOICES_DATATABLE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/invoicesReducer.js